import { getRGAStateByAbbreviationOrName } from '../data/rgaStates'

export function isRGAState(state: string) {
  const rgaState = getRGAStateByAbbreviationOrName(state)
  return !!rgaState
}
